var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_16",
    "data-name": "Layer 16",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.58,3.04c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5ZM17.58,11.04c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5,3.5,1.57,3.5,3.5-1.57,3.5-3.5,3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.06,15.97h-.09v-2.88h-1v2.88H6.01v-5.98c0-2.74,1.85-5.13,4.5-5.8l.38-.09v-.56c0-.59.46-1.05,1.05-1.05s1.05.46,1.05,1.05v.15h1v-.15c0-1.13-.92-2.05-2.05-2.05-1.06,0-1.93.81-2.04,1.84-2.9.9-4.89,3.59-4.89,6.66v5.98h-.03c-1.1,0-1.99.89-1.99,1.99s.89,1.99,1.99,1.99h4.06c.23,1.21,1.3,2.13,2.58,2.13h.77c1.28,0,2.34-.92,2.58-2.13h4.1c1.1,0,1.99-.89,1.99-1.99s-.89-1.99-1.99-1.99ZM12.38,21.07h-.77c-.72,0-1.34-.47-1.55-1.13h3.86c-.21.65-.83,1.13-1.55,1.13ZM19.06,18.95H4.98c-.55,0-.99-.44-.99-.99s.44-.99.99-.99h.03s13.96,0,13.96,0h0s.09,0,.09,0c.55,0,.99.44.99.99s-.44.99-.99.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.19,4.92h-.98c-.14,0-.24.12-.24.18l.49,3.48c.05.34.42.34.46.08l.49-3.48c.02-.14-.09-.26-.23-.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.7,9.22c-.26,0-.47.21-.47.47s.21.47.47.47.47-.21.47-.47-.21-.47-.47-.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertas);
export default __webpack_public_path__ + "static/media/alertas.824bde5310fcbd996498c1b1760fbc64.svg";
export { ForwardRef as ReactComponent };